import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('discardConfettiOption', function () {
    var optionState = getStore();
    optionState.isEnabled = null;
});
//# sourceMappingURL=discardConfettiOption.js.map